import React, { useState, useEffect } from 'react'
import ReactTable from 'react-table-v6'
import { Columns } from './Columns'
import Export from './Export'
import { GET_DATA_PROTECTION_JOBS } from "./Query"
import { Query } from "Utilities/incognitaAPI"
import { Button } from 'react-bootstrap'
import Icon from 'UI/FontAwesomeIcon'

const Jobs = ({ filters, setLoading, loading }) => {
  const [pageSize, setPageSize] = useState(10)
  const [pageNumber, setPageNumber] = useState(1)
  const [data, setData] = useState([])

  const NoDataComponent = () => (
    <div className="text-center font-medium text-lg py-3 text-gray-500">
      No jobs found
    </div>
  )

  // First page is indexed as 0
  const page = pageNumber - 1
  const handlePageNumber = number => setPageNumber(number + 1)

  const exportData = () => {
    const exportData = [...data]
    const dataSize = pageSize * pageNumber

    if (data.length > dataSize) exportData.pop() 

    return exportData
  }

  const filterValues = filter => filter.map(({ value }) => value)


  const search = () => {
    setLoading(true)
    setData([])

    const variables = {
      pageNumber,
      pageSize,
      storagePolicyIds: filterValues(filters.storagePolicies),
      customerIds: filterValues(filters.customers),
      commcellIds: filterValues(filters.commcells),
      locationIds: filterValues(filters.locations),
      statuses: filterValues(filters.statuses),
      subclients: filterValues(filters.subclients),
      outOfSchedule: filters?.outOfSchedule?.value,
      jobTypes: filterValues(filters.jobTypes)
    }
    
    Query(GET_DATA_PROTECTION_JOBS, variables)
      .then(({ dataProtectionJobs }) => setData(dataProtectionJobs))
      .finally(() => setLoading(false))
  }

  useEffect(search, [])

  return (
    <div>
      <div className="flex justify-end mb-4 -mt-16">
        <Button
          className="mr-4"
          disabled={loading}
          onClick={search}
          variant="outline-primary"
        >
          <Icon className="mr-2" icon="search" />
          <span>Search</span>
        </Button>

        <Export
          data={exportData()}
          loading={loading}
        />
      </div>


      <ReactTable
        data={data}
        columns={Columns}
        loading={loading}
        minRows={0}
        pageSize={pageSize}
        page={page}
        onPageChange={handlePageNumber}
        onPageSizeChange={setPageSize}
        NoDataComponent={NoDataComponent}
      />
  </div>
  )
}

export default Jobs
